import { useMutation, useQuery } from '@tanstack/vue-query';
import { npsSurveysService } from '@/api/nps-surveys.service';
import type { CompleteNpsSurveyDto } from '@carvia/ros-client-types';

export const useNpsSurvey = (id: string, key: string) =>
  useQuery({
    queryKey: ['nps-surveys', id],
    queryFn: async () => {
      return npsSurveysService.getNpsSurvey(id, key);
    },
  });

interface CompleteNpsSurveyVars {
  id: string;
  key: string;
  survey: CompleteNpsSurveyDto;
}

export const useCompleteNpsSurvey = (
  onSuccess: (variables: CompleteNpsSurveyVars) => void,
  onError: (variables: CompleteNpsSurveyVars) => void,
) =>
  useMutation({
    onSuccess(data, variables, context) {
      onSuccess?.(variables);
    },
    onError(error, variables, context) {
      onError?.(variables);
    },

    mutationKey: ['nps-surveys'],
    mutationFn: (vars: CompleteNpsSurveyVars) =>
      npsSurveysService.complete(vars.id, vars.key, vars.survey),
  });
